<template>
	<div class="rightSide-section d-flex withoutPOP">
		<div class="leftShow-bar ">
		    <div class="tablist-one scrollbar" v-show="tab == 'watchlist'">
		    	<div class="columnTwo-snd">
		    		<app-buyselltabing :currency_pair="currency_pair" :modifyTradeDetail="modifyTradeDetail" :modifyOrderDetail="modifyOrderDetail" @clearTrade="callClearTrade" v-if="instruments[currency_pair]" :placetradeDetail="placetradeDetail"> </app-buyselltabing>
		    		<div class="buySell-rightTop" v-else>
        				<div class="showModal custom-modal">
        					<div class="buySell-popup text-center pt-1 d-block">
			                    <p class="text-center currencyPath border-bottom px-2">
			                        <span class="f-14 font-weight-bold">{{currency_pair}}</span>
			                        <span></span>
			                    </p>
			                    <ul class="toggleButton d-inline-flex align-items-center justify-content-center">
			                        <li>
			                            <a class="redBG" href="javascript:void(0)">{{$t('sell')}} <span></span></a>
			                        </li>
			                        <li class="actives">
			                            <a class="greenBG" href="javascript:void(0)">{{$t('buy')}} <span></span></a>
			                        </li>
			                    </ul>
			                    <div class="mainContent buy">
			                    	<app-loader/>
			                   	</div>
			                </div>
			            </div>
			        </div>
		    	</div>
				<div class="columnOne" v-if="showDepth"><!--  v-if="bid.length > 0 && bid.length > 0" -->
						<!-- {{orderBook}} -->
					<!-- {{orderBook}} -->
					<div class="midGraph mt-2">
					 	<!-- <img src="../../../../../static/website/images/graph-Chart.png" alt="Graph"> -->
					 	<div class="btmContent overflow-hidden" id="marketdepth">
							<div class="headerTitle">
							 	<h6 class="d-flex align-items-center justify-content-between">{{$t('symbol_information')}}<span class="green">{{currency_pair}}</span></h6>
							 	<!-- <a class="iconResize" href="#" @click.prevent="marketdepthPopup = !marketdepthPopup" v-if="orderBook[currency_pair]"><i class="icon-resize"></i></a> -->
								<!-- <button type="button" class="appButton-r d-flex align-items-center justify-content-between" @click="openFullscreen()" v-if="orderBook[currency_pair]">
	                            	<feather size="16px" type="minimize"></feather>
	                        	</button> -->
	                        </div>
							<div class="headerTitle mainPerformance d-flex" v-if="instruments[currency_pair]">
								<ul class="listTotal">
									<li>{{$t('spread')}}  <span>{{(instruments[currency_pair].other.Spread)}}</span></li>
									<!-- <li>{{$t('symbol_information')}} <span>{{(instruments[currency_pair].other.Tick_Size.split('.')[1].length)}}</span></li> -->
									<!-- <li>{{$t('symbol_information')}} Levels: <span>10</span></li> -->
									<li>{{$t('contact_size')}} <span>{{instruments[currency_pair].other.Contract_Size}}</span></li>
									<li>{{$t('type')}} <span>{{instruments[currency_pair].other.type=='INDICIES'?'INDICES':instruments[currency_pair].other.type}}</span></li>
									<li>{{$t('min_tick_size')}} <span>{{instruments[currency_pair].other.Tick_Size}}</span></li>
									<li>{{$t('min_lot')}} <span>{{instruments[currency_pair].other.Min_Trade_Size}}</span></li>
									<li>{{$t('max_lot')}} <span>{{instruments[currency_pair].other.Max_Trade_Size}}</span></li>
									<li>{{$t('pip_size')}} <span>{{instruments[currency_pair].other.pip_size}}</span></li>
									<li>{{$t('stop_limit_levels')}} <span>{{instruments[currency_pair].other.condition_distance}}</span></li>
									<li>{{$t('base_currency')}} <span>{{instruments[currency_pair].other.base_currency}}</span></li>
									<li>{{$t('swap_type')}} <span>{{instruments[currency_pair].other.swap_type}}</span></li>
									<li>{{$t('swap_long')}} <span>{{instruments[currency_pair].other.Long_Swaps}}</span></li>
									<li>{{$t('swap_short')}} <span>{{instruments[currency_pair].other.Short_Swaps}}</span></li>
								</ul>
								<!-- <table class="table depthChartTable border-0" v-if="instruments[currency_pair] && instruments[currency_pair]['other']">
									<thead>
										<tr>
											<th>Qty</th>
											<th class="text-right">{{ instruments[currency_pair]['other'] }}</th>
										</tr>
									</thead>
									<tbody>

										
										<tr v-for="item in getDepthValue('buy')">
											<td>{{item.Quantity}}</td>
											<td class="green text-right">{{item.Rate}}</td>
										</tr>


									</tbody>
								</table> -->
							</div>
							<!-- <div class="poweredBy position-fixed left-0 px-2 py-2">
								<strong class="font-italic">Powered By:</strong><span> Act Trader</span>
							</div> -->
						 </div>
					</div>
				</div>
			</div>
		    <!---->
		    <div class="tablist-two h-100 position-relative" v-if="tab == 'news'">
				<app-loader v-if="pageLoader" style="z-index: 99 !important"/>
				<div class="headerTitle d-flex align-items-center justify-content-between mb-1 tradeBuySell">
				 	<h6>{{$t('news') }} </h6>
				 	<a class="iconResize" @click.prevent="$parent.newsPopup = !$parent.newsPopup" href="#"><i class="icon-resize"></i></a>
				 	<!-- <app-newspopup v-if="newsPopup"></app-newspopup> -->
				</div>
		    	<app-news-section></app-news-section>
			</div>
		    
		    <EconomicCalendar v-if="tab == 'calendar'"></EconomicCalendar> 
		    
		    <div class="tablist-five h-100 position-relative" v-if="tab == 'notification'">
		    	<div class="headerTitle d-flex align-items-center justify-content-between mb-1">
				 	<h6> {{$t('alerts') }} </h6>
				 	<span class="iconResize opacityIco"><feather size="16px" type="clock"></feather> </span>
				</div>
		    	<price-alert-tab :currency_pair="currency_pair"/>
		    </div>
		</div>
		<div class="rightTabs">
			<ul class="maskIcon">
				<li class="copy-rightICo" v-if="['market101'].includes(product)">					
					<a data-title="Copy Trade" href="/leaders" class="">
						<feather type="copy" class="white"></feather> 
						<span class="bar_title">{{$t('copy_trade') }}</span>
					</a>
				</li>
				<li :class="(tab == 'watchlist')?'active':' '">
					<a data-title="Watchlist" @click.prevent="tab = 'watchlist'" href="#"><i class="icon-1"></i> <span class="bar_title">{{$t('watchlist')}}</span></a>
				</li>
				<li data-title="News" :class="(tab == 'news')?'active':' '">
					<a @click.prevent="tab = 'news'" href="#"><i class="icon-2"></i><span class="bar_title">{{$t('news')}}</span> </a>
				</li>
				<!-- <li :class="(tab == 'tradelist')?'active':' '">
					<a  @click.prevent="tab = 'tradelist'" href="#"><i class="icon-3"></i></a>
				</li> -->
				<li data-title="Calendar" :class="(tab == 'calendar')?'active':' '">
					<a  @click.prevent="tab = 'calendar'" href="#"><i class="icon-4"></i>
					<span class="bar_title">{{$t('calendar')}}</span></a>
				</li>
				<li :class="(tab == 'notification')?'active':''">
					<a class="appButton-r d-block align-items-center justify-content-center" data-title="Alert" @click.prevent="tab = 'notification'" href="#">
						<span class="maskElement alertIcon d-block m-auto"></span>
						<span class="bar_title">{{$t('alert')}}</span>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import buy_sell_tabing from './buy-sell-tabing'
	import newsSection from './news-section'
	import EconomicCalendar from './Economic-Calendar'
	import { commonAllmixins } from '@/plugins/commonAll'
	// import depth_chart from './depth-chart'
	import price_alert_tab from './price-alert-tab'
	import { Const } from '@/plugins/vue-provider-cache/const.mod'
	const product = process.env.product;
	export default {
	    name: 'Right-Section',
	    mixins: [commonAllmixins],
	    data() {
	        return {
	        	pageLoader : false,
				tab: 'watchlist',
				accordian: '1',
				showDepth:true,
				bid: [],
				ask: [],
				alertType : 1,
				marketdepthPopup : false,
				product
	        }
	    },
	    components:{
	    	AppBuyselltabing: buy_sell_tabing,
	    	AppNewsSection: newsSection,
	    	// appDepthChart : depth_chart,
	    	priceAlertTab : price_alert_tab,
	    	EconomicCalendar,
	    },
	    props:['currency_pair','modifyTradeDetail','modifyOrderDetail', "placetradeDetail"],
		emits:['clearTrade'],
	    watch:{
	    	/*currency_pair(val){
				try{
					this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].orderBook({symbol:val})
				}catch(e){}
	    		this.bid =[]
	    		this.ask =[]
	    	}*/
	    },
	    methods:{
			callClearTrade(){
				this.$emit('clearTrade')
			},
	    	getDepthValue(type){
	            try{
	                let _that =  this
	                if(type == 'buy'){
	                    return this.orderBook[this.currency_pair].buy.filter(val=> val.Rate <= _that.instruments[_that.currency_pair].B).slice(0,10)
	                }else if(type == 'sell'){
	                    return this.orderBook[this.currency_pair].sell.filter(val=> val.Rate >= _that.instruments[_that.currency_pair].A).slice(0,10)
	                }else{
	                    return []
	                }
	            }catch(e){ return [] }
	        },
	    	openFullscreen() {
	            if(document.fullscreenElement){
	                document.exitFullscreen();
	            }else{
	            	// this.marketdepthPopup = true
	                var elem = document.getElementById("marketdepth");
	                if (elem.requestFullscreen) {
	                    elem.requestFullscreen();
	                } else if (elem.webkitRequestFullscreen) { /* Safari */
	                    elem.webkitRequestFullscreen();
	                } else if (elem.msRequestFullscreen) { /* IE11 */
	                    elem.msRequestFullscreen();
	                }
	            }
        	},
	    	/*AddRemIndex(value){
	    		if(this.indexNo == value){
	    			this.indexNo = ''
	    		}else{
	    			this.indexNo = value
	    		}
	    	}*/
	    	createChart(){
				if(this.showDepth){
					try{
						/*if(this.orderBook[this.currency_pair] && this.orderBook[this.currency_pair].buy &&  this.orderBook[this.currency_pair].sell){
							let data = this.orderBook[this.currency_pair]
							let data = this.orderBook[this.currency_pair]*/
						if(this.getDepthValue('buy').length && this.getDepthValue('sell').length){
							let bid = this.getDepthValue('buy').map(val=>[val.Rate,val.Quantity])
							let ask = this.getDepthValue('sell').map(val=>[val.Rate,val.Quantity])
							if(bid.length > 0 && ask.length > 0){
								// console.log('bid ask change')
								this.bid = bid
								this.ask = ask
								try{
									this.$refs.depth_chart.dataChange()
								}catch(e){}
							}
						}else{
							try{
								this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].orderBook({'symbol':this.currency_pair})
							}catch(e){}
						}
					}catch(e){}
				}
	    	}
	    },
	    computed:{
			showDepth(){
				return !['Copyrack'].includes(product)
			},
    		instruments() {
	    	    try {                    
		            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
		            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
		        } catch (ex) {                
		            return []
		        }
		    },
		    contractSize(){
	    		try{
		    		return this.currencyPairs.filter(val=>val.isinid.includes( this.symbol))[0].market_ContractSize || 100000
		    	}catch(e){ return 100000 }
	    	},
	    	
	    },
	    created(){
	    	// this._runGetNewsData({'globalParams' : {} ,'localParams' : {'parameter' : this}})
	    	// let _that =  this
	    	// setTimeout(function(){
	    	// 	_that.createChart()
	    	// }, 5000);
	    },
	    mounted() {
	    	// document.getElementById('marketdepth').addEventListener('fullscreenchange', (event) => {
	        //     if (document.fullscreenElement) {
	        //         document.getElementById('marketdepth').classList.add("fullscreen")
	        //         // console.log(`Element: ${document.fullscreenElement.id} entered fullscreen mode.`);
	        //     } else {
	        //         document.getElementById('marketdepth').classList.remove("fullscreen")
	        //         // console.log('Leaving full-screen mode.');
	        //     }
	        // });
		}
		
	}
</script>


// WEBPACK FOOTER //
// src/components/website/user/home-elements/right-sec.vue